import { TAX_PAYMENT_PERIOD_TYPES_ENUM } from 'src/common/enums';
import { RootState } from 'src/store/store';
import { PeriodType } from 'src/types/tax';

export const selectTaxState = (state: RootState) => state.tax;
export const selectTaxPaymentPeriodsState = (state: RootState) => {
  return { ...state.tax.taxPaymentPeriods, data: undefined };
};
export const selectTaxPaymentPeriods = (state: RootState) => {
  const key: PeriodType =
    state.tax.selectedPeriodType ?? TAX_PAYMENT_PERIOD_TYPES_ENUM.MONTHLY;

  return state.tax.taxPaymentPeriods?.data?.[key] || [];
};

export const selectTaxSteps = (state: RootState) => state.tax.taxSteps;
export const selectCalculatedTaxData = (state: RootState) =>
  state.tax.calculatedTaxData;
export const selectCalculatedTaxInProgress = (state: RootState) =>
  state.tax.isCalculateTaxInProgress;
export const selectCalculatedTaxSuccess = (state: RootState) =>
  state.tax.isCalculateTaxSuccess;
export const selectCalculateTaxErrorMsg = (state: RootState) =>
  state.tax.calculatedTaxErrorMsg;

export const selectPreSelectedTaxPeriod = (state: RootState) =>
  state.tax.preSelectedPeriod;

export const selectTaxFlowData = (state: RootState) => state.tax.taxFlowData;

export const selectLicensesPerPeriod = (state: RootState) => {
  const key: PeriodType =
    state.tax.selectedPeriodType ?? TAX_PAYMENT_PERIOD_TYPES_ENUM.MONTHLY;
  return state.tax.licensesPerPeriod[key];
};
